// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-datepicker.reschedule-demo-datepicker .react-datepicker__header {
  padding: 0;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation--previous,
.react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation--next {
  top: 12px;
  border-radius: 12px;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation--previous {
  left: 10px;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation--next {
  right: 10px;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation--previous:hover,
.react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation--next:hover {
  background-color: none !important;
  border: 1px solid #2563EB;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation--previous:hover .react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation-icon--previous::before,
.react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation--next:hover .react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation-icon--next::before {
  border-color: #2563EB;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__day-names {
  padding: 0;
  margin: 2px 0;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__day-name {
  width: 48px !important;
  height: 32px !important;
  margin: 0;
  color: #474853;
  line-height: 20px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__header__dropdown {
  height: 0;
}

.react-datepicker.reschedule-demo-datepicker {
  width: 336px;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__month-container {
  width: 336px;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__current-month {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: #11113A;
  height: 56px;
  margin-bottom: 2px;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__month {
  padding: 0;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__week {
  display: block;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__day {
  width: 48px;
  height: auto;
  margin: 0;
  border: 1px solid transparent;
  display: inline-block;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  color: #11113A !important;
  font-size: 14px;
  line-height: 38px;
  font-weight: 400;
  box-sizing: border-box;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__day:hover {
  border-color: #2563EB;
  color: #11113A;
  background-color: transparent !important;
  border-radius: 14px !important;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--selected,
.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--in-selecting-range,
.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--range-end,
.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--range-start,
.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--in-range {
  background-color: #2563EB !important;
  color: #ffffff !important;
  border: 1px solid #2563EB;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--outside-month:hover,
.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--selected:hover,
.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--in-selecting-range:hover,
.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--range-end:hover,
.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--range-start:hover,
.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--in-range:hover {
  background-color: #ffffff !important;
  color: #2563EB !important;
  border: 1px solid #2563EB;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--outside-month {
  border: none;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__month-container:first-of-type {
  border-right: none;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--disabled {
  background-color: transparent !important;
  color: #7A858F !important;
  border: 1px solid transparent;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--disabled:hover {
  background-color: transparent !important;
  color: #7A858F !important;
  border: 1px solid transparent;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker__input-time-container {
  margin: 16px 0 0;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker-time__input-container {
  width: 100%;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker-time__input {
  width: 100%;
  margin: 0;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker-time__input .react-datepicker-time__input {
  width: 100%;
  height: 48px;
  padding: 10px 16px;
  margin: 0;
  border: 1px solid #60A2E34D;
  border-radius: 12px;
  outline: none;
  font-size: 18px;
  line-height: 24px;
  color: #11113A;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker-time__input .react-datepicker-time__input:hover {
  border-color: #60A2E380;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker-time__input .react-datepicker-time__input:focus {
  border-color: #9747FF;
}

.react-datepicker.reschedule-demo-datepicker .react-datepicker-time__input::-webkit-calendar-picker-indicator {
  filter: invert(69%) sepia(14%) saturate(1307%) hue-rotate(174deg) brightness(93%) contrast(92%);
  width: 20px;
  height: 20px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/RescheduleDemoModal/react-date-picker.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;;EAEE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;;;;;EAKE,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;;;EAME,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+FAA+F;EAC/F,WAAW;EACX,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".react-datepicker.reschedule-demo-datepicker .react-datepicker__header {\n  padding: 0;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation--previous,\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation--next {\n  top: 12px;\n  border-radius: 12px;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation--previous {\n  left: 10px;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation--next {\n  right: 10px;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation--previous:hover,\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation--next:hover {\n  background-color: none !important;\n  border: 1px solid #2563EB;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation--previous:hover .react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation-icon--previous::before,\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation--next:hover .react-datepicker.reschedule-demo-datepicker .react-datepicker__navigation-icon--next::before {\n  border-color: #2563EB;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day-names {\n  padding: 0;\n  margin: 2px 0;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day-name {\n  width: 48px !important;\n  height: 32px !important;\n  margin: 0;\n  color: #474853;\n  line-height: 20px;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__header__dropdown {\n  height: 0;\n}\n\n.react-datepicker.reschedule-demo-datepicker {\n  width: 336px;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__month-container {\n  width: 336px;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__current-month {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 500;\n  color: #11113A;\n  height: 56px;\n  margin-bottom: 2px;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__month {\n  padding: 0;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__week {\n  display: block;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day {\n  width: 48px;\n  height: auto;\n  margin: 0;\n  border: 1px solid transparent;\n  display: inline-block;\n  align-items: center;\n  justify-content: center;\n  border-radius: 14px;\n  color: #11113A !important;\n  font-size: 14px;\n  line-height: 38px;\n  font-weight: 400;\n  box-sizing: border-box;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day:hover {\n  border-color: #2563EB;\n  color: #11113A;\n  background-color: transparent !important;\n  border-radius: 14px !important;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--selected,\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--in-selecting-range,\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--range-end,\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--range-start,\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--in-range {\n  background-color: #2563EB !important;\n  color: #ffffff !important;\n  border: 1px solid #2563EB;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--outside-month:hover,\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--selected:hover,\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--in-selecting-range:hover,\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--range-end:hover,\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--range-start:hover,\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--in-range:hover {\n  background-color: #ffffff !important;\n  color: #2563EB !important;\n  border: 1px solid #2563EB;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--outside-month {\n  border: none;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__month-container:first-of-type {\n  border-right: none;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--disabled {\n  background-color: transparent !important;\n  color: #7A858F !important;\n  border: 1px solid transparent;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__day--disabled:hover {\n  background-color: transparent !important;\n  color: #7A858F !important;\n  border: 1px solid transparent;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker__input-time-container {\n  margin: 16px 0 0;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker-time__input-container {\n  width: 100%;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker-time__input {\n  width: 100%;\n  margin: 0;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker-time__input .react-datepicker-time__input {\n  width: 100%;\n  height: 48px;\n  padding: 10px 16px;\n  margin: 0;\n  border: 1px solid #60A2E34D;\n  border-radius: 12px;\n  outline: none;\n  font-size: 18px;\n  line-height: 24px;\n  color: #11113A;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker-time__input .react-datepicker-time__input:hover {\n  border-color: #60A2E380;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker-time__input .react-datepicker-time__input:focus {\n  border-color: #9747FF;\n}\n\n.react-datepicker.reschedule-demo-datepicker .react-datepicker-time__input::-webkit-calendar-picker-indicator {\n  filter: invert(69%) sepia(14%) saturate(1307%) hue-rotate(174deg) brightness(93%) contrast(92%);\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
